import './hero.component.scss'

import 'holy-stars/index.css'
import HolyStars from 'holy-stars'

const heroSectionEl = document.querySelector('.hero')

class HeroSection {
  constructor() {
    this.elements = {
      section: heroSectionEl,
      rateWraps: document.querySelectorAll('.hero-badge-item__rate-stars'),
      stickyBadge: document.querySelector('.hero-badge-item_sticky')
    }

    this.init()
  }

  defineStars() {
    this.elements.rateWraps.forEach(wrap => {
      const num = +wrap.textContent
      new HolyStars({
        el: wrap,
        rate: +num,
        size: 12,
        primaryColor: '#FBCE2F',
        secondColor: '#FFFFFF'
      })
    })
  }

  defineStickyBadge() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if(entry.isIntersecting) {
          this.elements.stickyBadge.classList.remove('sticked')
        } else {
          this.elements.stickyBadge.classList.add('sticked')
        }
      })
    }, {
      rootMargin: '10% 0px 10% 0px'
    })
    observer.observe(this.elements.section)
  }

  init() {
    this.defineStars()
    
    if (this.elements.stickyBadge) {
      this.defineStickyBadge()
    }
  }
}

if (heroSectionEl) {
  new HeroSection()

  const bodyEl = document.querySelector('body')
  let gglBadge

  const observer = new MutationObserver(mutationRecords => {
    if (mutationRecords[0].target.innerText) {
      gglBadge = document.querySelector('[class*="BadgeTotalReviews__Content"]')

      if (gglBadge) {
        const value = gglBadge.innerHTML.match(/\d+/g).join('')
        
        if (value) {
          const numEl = document.querySelector('.hero-badge-item__rate-text-num')
          if (numEl) {
            numEl.innerHTML = value
          }
          
          observer.disconnect()
        }
      }
    }
  })
  
  observer.observe(bodyEl, {
    childList: true,
    subtree: true,
    characterDataOldValue: true
  })
}